<template>
  <div class="base-slider-wrapper">
    <BaseSlider
      v-model="_value"
      :disabled="disabled"
      :min="min"
      :max="max"
      :interval="interval" />
    <BaseErrorMessage
      :color="errorTextColor"
      :bold="errorTextBold"
      :errors="responseFieldErrors" />
  </div>
</template>

<script>
import BaseSlider from '@/components/parts/BaseSlider.vue'
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'

export default {
  components: {
    BaseSlider,
    BaseErrorMessage
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    interval: {
      type: [String, Number],
      default: 1
    },
    min: {
      type: [String, Number],
      required: true,
    },
    max: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    responseErrors: {
      type: Object,
      default: null
    },
    errorTextColor: {
      type: String,
      default: 'primary'
    },
    errorTextBold: {
      type: Boolean,
      default: false
    },
    vid: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v) 
      }
    },
    responseFieldErrors() {
      return [this.responseErrors?.[this.vid]] || []
    }
  }
}
</script>

<style lang="scss">
.base-slider-wrapper {
  width: 100%;
}
</style>